module.exports = __webpack_public_path__ + "img/card_icon_v1_visa.0a014f36.svg";